// extracted by mini-css-extract-plugin
export default {"update":"update__tSqhu_6wwqKT","warning":"warning__A0e_PPKExjuj"};